module.exports = __webpack_public_path__ + "static/media/cat-sleep.d4fd544d.jpg";